/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const EmailFormFragment = {
  EmailForm: gql`
    fragment EmailFormQuery on emailForm_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      formVertical
      ctaLabel
      ctaType
      formContent
      formType
      lineBreak_mainContent
      lineBreak_styles
      showNameField
      showParentEmailField
      showPhoneNumberField
      hideEmailField
      emailFormImage {
        url
        ... on images_Asset {
          altText
        }
      }
      imageAlignment
      styles
      subscriptionListIds
      typeHandle
    }
  `,
};
